<template>
  <dd class="mt-4" :class="[$theme.baseTextColor]">
    <ul role="list" class="">
      <li
          v-for="(document, docIdx) in documents" :key="document.id"
          class="flex items-center justify-between leading-6 py-4"
          :class="[
              $theme.cardBorderColor,
              docIdx !== 0 ? 'border-t' : ''
          ]"
      >
        <div class="flex w-0 flex-1 items-center">
          <div class="flex min-w-0 flex-1 gap-2">
            <span class="truncate">{{ document.title }}</span>
          </div>
        </div>
        <div class="ml-3 flex-shrink-0">
          <a :href="document.file" target="_blank" class="font-medium flex items-center" :class="[$theme.navActiveTextColor2]">
            {{ $t('view') }}
            <ArrowUpIcon class="w-5 ml-1" :class="[$theme.IconSvgColor]" />
          </a>
        </div>
      </li>
    </ul>
  </dd>
</template>
<script>
import ArrowUpIcon from "@/assets/icons/ArrowUpIcon.vue";

export default {
  props: [
    'documents'
  ],

  components: {
    ArrowUpIcon
  },
};
</script>